import { Component, ErrorInfo, Fragment, ReactNode } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  resetKey: number;
};

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    resetKey: 0,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState((prev) => ({
      hasError: false,
      resetKey: prev.resetKey + 1,
    }));
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            p: 4,
            maxWidth: 480,
            mx: "auto",
            mt: 8,
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h6">Algo deu errado</Typography>
            <Typography variant="body2" color="text.secondary">
              Não foi possível carregar esta tela. Tente novamente ou recarregue
              a página.
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" onClick={this.handleRetry}>
                Tentar novamente
              </Button>
              <Button variant="outlined" onClick={this.handleReload}>
                Recarregar página
              </Button>
            </Stack>
          </Stack>
        </Box>
      );
    }

    return <Fragment key={this.state.resetKey}>{this.props.children}</Fragment>;
  }
}

export default ErrorBoundary;
